// extracted by mini-css-extract-plugin
module.exports = {"companyTitle":"style_companyTitle__1R_GQ","companyAdress":"style_companyAdress__1rE0N"};